export const serviceResponse = `
status
error
message
version
service
`;
